/* globals window , $ */
'use strict';

function initOnShow(root, elemFunc) {
  $(root)
    .find('.uninitialized')
    .each(function () {
      let e = this;
      let f = function (event) {
        let rect = e.getBoundingClientRect();
        let offset = 160;
        let elemTop = rect.top;
        let elemBottom = rect.bottom;
        let visible = elemTop >= 0 && elemBottom <= window.innerHeight + offset;
        if (visible) {
          $(window).unbind(event);
          $(e).removeClass('uninitialized');
          if (elemFunc) {
            elemFunc(e);
          }
        }
      };
      $(window).bind('scroll', f);
    });
}

$(function () {
  let root = $('.hallbart');

  initOnShow(root.find('.sustainability-levels'));

  initOnShow(root.find('.carbon-footprint .co2-graph'), function (el) {
    const animTime = 1400;
    let start = null;
    let e = $(el);
    let targetValue = parseFloat(e.find('.co2-graph-value').data('value'));
    let ve = e.find('.co2-graph-value');

    function step(timestamp) {
      if (!start) {
        start = timestamp;
      }
      var progress = timestamp - start;
      ve.text(
        (targetValue * Math.min(1, progress / animTime))
          .toFixed(1)
          .replace('-', '−')
          .replace('.', ',') + ' %',
      );
      if (progress < animTime) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  });

  initOnShow(root.find('.fossile-exposure .graph'), function (el) {
    const animTime = 1400;
    let start = null;
    let e = $(el);
    let targetValue = parseFloat(e.find('.graph__value').data('value'));
    let ve = e.find('.graph__value');

    function step(timestamp) {
      if (!start) {
        start = timestamp;
      }
      var progress = timestamp - start;
      ve.text(
        (targetValue * Math.min(1, progress / animTime))
          .toFixed(1)
          .replace('-', '−')
          .replace('.', ',') + ' %',
      );
      if (progress < animTime) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  });

  root
    .find('.sustainability-comparison tbody td span:not(.cross)')
    .addClass('uninitialized');

  const comparison = root.find('.sustainability-comparison .table');
  $(window).bind('scroll.sustainability-comparison', function () {
    let rect = comparison[0].getBoundingClientRect();
    let offset = 160;
    let elemTop = rect.top;
    let elemBottom = rect.bottom;
    let visible = elemTop >= 0 && elemBottom <= window.innerHeight + offset;
    if (visible) {
      $(window).unbind('.sustainability-comparison');
      comparison.find('.uninitialized').each(function (i, e) {
        let delay = i * 60;
        setTimeout(function () {
          $(e).removeClass('uninitialized');
        }, delay);
      });
    }
  });
});
